
const FullStack = () => {
  return (
    <div className="mt-4 text-center">
      <h1 className="display-6 text-success">Full Stack Path</h1>
      <p>
        Become a software and application developer, well-equipped with both
        front-end and back-end.
      </p>
      <img
        src="https://clarusway.com/wp-content/uploads/elementor/thumbs/v1-Fullstack-developer-pqnf31gbxlt9gholzgwtsxya1abhwiwulezoqna3wo.jpg"
        alt=""
        className="img-fluid"
      />
      <div className="container mb-5">
        <button className="btn btn-outline-success btn-light mt-4 mb-4">Learn More</button>
      </div>
    </div>
  );
};

export default FullStack;
